import React from 'react';

const InsightsIcon = () => {
  return (
    <svg className="platform-icon allservices-icon" width="28" height="28" viewBox="0 0 38 38">
      <defs>
        <style>
          {`.fd697ec5-dedd-4cbd-b54c-c319c7282cac{fill: #fff;}`}
          {`.b71bb37e-4f3b-4552-bf19-fa5bca65c863{fill: #e00;}`}
        </style>
      </defs>
      <path d="M28,1H10a9,9,0,0,0-9,9V28a9,9,0,0,0,9,9H28a9,9,0,0,0,9-9V10a9,9,0,0,0-9-9Z" />
      <path
        className="fd697ec5-dedd-4cbd-b54c-c319c7282cac"
        d="M27.38,11.09a.62.62,0,0,0-.16-.31h0A11.54,11.54,0,0,0,19,7.38a.61.61,0,0,0-.62.62v8.46A2.62,2.62,0,1,0,21.62,19a2.56,2.56,0,0,0-.38-1.35l6-6A.61.61,0,0,0,27.38,11.09Zm-1.51.15-5.52,5.52a2.49,2.49,0,0,0-.73-.3V8.64A10.28,10.28,0,0,1,25.87,11.24ZM19,20.38A1.38,1.38,0,1,1,20.38,19,1.38,1.38,0,0,1,19,20.38Z"
      />
      <path
        className="b71bb37e-4f3b-4552-bf19-fa5bca65c863"
        d="M19,29.62A10.63,10.63,0,0,1,15.81,8.86a.64.64,0,0,1,.79.41.62.62,0,0,1-.41.78,9.39,9.39,0,1,0,10.93,4.26.62.62,0,0,1,.23-.85.61.61,0,0,1,.85.23A10.62,10.62,0,0,1,19,29.62Z"
      />
      <path
        className="b71bb37e-4f3b-4552-bf19-fa5bca65c863"
        d="M19,25.62a6.62,6.62,0,0,1-3.31-12.36.62.62,0,1,1,.62,1.08,5.39,5.39,0,1,0,7.76,2.87.62.62,0,0,1,.38-.8.63.63,0,0,1,.8.38A6.64,6.64,0,0,1,19,25.62Z"
      />
    </svg>
  );
};
export default InsightsIcon;
